__turbopack_context__.v({
  "root": "CircularSpinner-module__MYRw2a__root",
  "rotate": "CircularSpinner-module__MYRw2a__rotate",
});
